import { ApiRequestConfig, apiService } from './api.service';

import { IEvent } from '@/interfaces/entities/event';
import { IApiService } from '@/interfaces/services/IApiService';
import { IEventService } from '@/interfaces/services/IEventService';

class EventService implements IEventService {
	api: IApiService<ApiRequestConfig>;

	constructor(api: IApiService<ApiRequestConfig>) {
		this.api = api;
	}

	async getAllEvents(pageNumber: number, config?: ApiRequestConfig) {
		const result = await this.api.get<{ data: IEvent[]; pageCount: number }>(
			`/event/admin?page[size]=10&page[number]=${pageNumber}&sort[createdAt]=DESC`,
			config,
		);
		console.log(result);
		return result;
	}

	async changeStatus(id: number, status: string, config?: ApiRequestConfig) {
		return await this.api.patch<IEvent>(
			`/event/admin/status/${id}`,
			{ status },
			config,
		);
	}
}

export const eventService = new EventService(apiService);
